import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { VtxFormLayout } from '@vtx/components';
const BaseContent = ({ info }) => {
    return (
        <Form layout="inline">
            <VtxFormLayout mode="view" cols={1}>
                <VtxFormLayout.FormItem label="设备类型">
                    {info.equipmentTypeValue || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="浓度值">
                    {info.gasConcentration || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="阈值">
                    {info.threshold || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="位置">
                    {info.threshold ? '进口' : '出口'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="甲烷浓度">
                    {info.methaneConcentration || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="温度">
                    {info.temperature || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="压力">
                    {info.pressure || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="报警结束时间">
                    {info.alarmEndTime || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="行政区划">
                    {info.divisionName || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="管理单位">
                    {info.manageUnitName || '--'}
                </VtxFormLayout.FormItem>
                <VtxFormLayout.FormItem label="描述">
                    {info.homeStepStatusStr || '--'}
                </VtxFormLayout.FormItem>
            </VtxFormLayout>
        </Form>
    );
};

BaseContent.propTypes = {
    info: PropTypes.object,
};

export default BaseContent;
